import { colors } from '../../../theme';
import { createOwnUpStyle } from '../../style';
export var OwnUpAppBarStyle = createOwnUpStyle({
  background: colors.PRIMARY,
  color: colors.WHITE,
  height: '60px',
  padding: '0 18px',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  variants: {
    minimal: {
      background: colors.WHITE
    },
    smallAndUp: {
      padding: '0 30px'
    }
  }
});